
import { defineComponent, SetupContext, getCurrentInstance, ref } from 'vue';
import Popup from 'vant/lib/popup';
import Toast from 'vant/lib/toast';
import VanField from 'vant/lib/field';

const MessageActionPopup = defineComponent({
    components: {
        Popup,
        VanField,
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        // feedPage: {
        //     type: String as PropType<AIFeedPageEnum> | undefined,
        //     default: AIFeedPageEnum.AIForyou,
        // },
    },
    setup(props, ctx: SetupContext<Array<'onCancel' | 'onOk'>>) {
        const { proxy } = getCurrentInstance() || {};
        const feedbackContent = ref<string>();

        const handleInputChange = (value: string) => {
            feedbackContent.value = value;
        };

        const handleCancel = () => {
            ctx.emit('onCancel');
            feedbackContent.value = '';
            Toast({
                message: proxy?.$root?.$t?.('k_1323882'),
            });
        };

        const handleOk = () => {
            ctx.emit('onOk', feedbackContent.value);
            feedbackContent.value = '';
            Toast({
                message: proxy?.$root?.$t?.('k_1323882'),
            });
        };

        return {
            feedbackContent,
            handleInputChange,

            handleCancel,
            handleOk,
        };
    },
});

export default MessageActionPopup;
